module.exports = __webpack_public_path__ + "static/hrpa-logo-1aa217b79f894bacb29a2f525d287cab.png";